// File Metadata:
// Version: 2.00
// Created: 2025-03-19 22:33:39
// Authors: Dieuwer Descheemaecker, Claude 3.7 Sonnet, GitHub Copilot
// Description: Entry point for the React application with Toolpad and Redux integration
// Last Modified: 2025-04-16
// Filename: main.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { AppProvider } from '@toolpad/core/AppProvider';
import { store } from './store';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
        <AppProvider>
          <App />
        </AppProvider>
    </Provider>
  </React.StrictMode>
);